export default __webpack_public_path__ + "static/media/gradosbrix.f0638f25.png";